import { useInView } from "../../../hooks/useInView";
import { useSiteContent } from "@/cms/SiteContentContext";
import { editableAttrs } from "@/cms/previewUtils";

const ContactSection = () => {
  const { ref, inView } = useInView();
  const { content } = useSiteContent();
  const section = content.home.contact;

  return (
    <section id="contact" className="bg-zinc-950 py-20 md:py-28" {...editableAttrs("home.contact", "object")}>
      <div className="max-w-7xl mx-auto px-6">
        <div ref={ref} className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <span className="w-10 h-px bg-red-600" />
            <span className="text-red-500 text-xs font-semibold tracking-widest uppercase" style={{ fontFamily: "Rajdhani, sans-serif" }} {...editableAttrs("home.contact.badge", "text")}>
              {section.badge}
            </span>
            <span className="w-10 h-px bg-red-600" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-3" style={{ fontFamily: "Rajdhani, sans-serif" }} {...editableAttrs("home.contact.title", "text")}>
            {section.title}
          </h2>
          <p className="text-zinc-400 text-sm max-w-lg mx-auto mt-4 leading-relaxed" {...editableAttrs("home.contact.description", "textarea")}>
            {section.description}
          </p>
        </div>

        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-10"
          style={{
            opacity: inView ? 1 : 0,
            transform: inView ? "translateY(0)" : "translateY(24px)",
            transition: "opacity 0.7s ease, transform 0.7s ease",
          }}
          {...editableAttrs("home.contact.items", "array")}
        >
          {section.items.map((item, i) => (
            <div
              key={`${item.title}-${i}`}
              className="bg-zinc-900 border border-zinc-800 hover:border-red-600/50 p-6 flex flex-col gap-4 transition-colors duration-300"
              style={{ transitionDelay: `${i * 0.08}s` }}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-red-600/10 border border-red-600/30">
                <i className={`${item.icon} text-red-500 text-xl`}></i>
              </div>
              <div>
                <div className="text-white font-bold text-base mb-2 tracking-wider uppercase" style={{ fontFamily: "Rajdhani, sans-serif" }}>
                  {item.title}
                </div>
                {item.lines.map((line, lineIndex) => (
                  <div key={`${line}-${lineIndex}`} className="text-zinc-400 text-sm leading-relaxed">
                    {line}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
